import React from "react";
import { ScheduleV2 } from "../../../types";
import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../redux/store";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";
import { setSelectedScheduleForCannotWork } from "../../../redux/features/schedule/ScheduleSlice";

interface ScheduleActionablesProps {
    schedule: ScheduleV2;
}

const ScheduleActionables: React.FC<ScheduleActionablesProps> = ({ schedule }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleCantWorkClicked = () => {
        dispatch(setTopNavNameTitle("What do you want to do?"));
        dispatch(setSelectedScheduleForCannotWork(schedule));
        navigate("/m-cannotwork-actionables");
    };
    const hasAnyActionable = schedule?.action_button && Object.values(schedule.action_button).some(Boolean);

    return (
        <div className="w-full p-4 bg-white border-t border-gray-300 flex space-x-2 fixed bottom-0 left-0">
            {/* <button
                className="bg-green-500 text-white py-2 px-4 rounded-lg shadow hover:bg-green-600 flex-1"
            >
                Publish
            </button> */}
            {hasAnyActionable && (
                <button
                    className="bg-red-500 text-white font-semibold py-2 px-4 text-size-md rounded-lg shadow hover:bg-gray-400 flex-1"
                    onClick={handleCantWorkClicked}
                >
                    Can't work
                </button>
            )}
        </div>
    );
};

export default ScheduleActionables;
